module.exports = __webpack_public_path__ + "static/media/MVNZ_web_4_preview.a8205f36.jpg";